import { type ReactElement } from 'react';
import { type LoadingErrorProps } from './interfaces';
import { Alert } from '@mantine/core';
import { IconAlertTriangleFilled } from '@tabler/icons-react';

export function LoadingError({ error }: LoadingErrorProps): ReactElement {
    return (
        <Alert color='red' title='Api error' icon={ <IconAlertTriangleFilled/> }>
            { error.message }
        </Alert>
    );
}